export default "__VITE_ASSET__c6443234__"